// modules
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import companies from 'data/companies';
import Jobs from 'components/Jobs';

// local
import styles from './JobList.pcss';

export default class JobList extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    jobs: PropTypes.arrayOf(PropTypes.shape({
      company: PropTypes.string,
      slug: PropTypes.string,
      title: PropTypes.string,
      dates: PropTypes.arrayOf(PropTypes.string),
      location: PropTypes.string,
      description: PropTypes.array,
    })),
  }
  static defaultProps = {
    jobs: [],
  }
  
  get jobs() {
    const { jobs } = this.props;
    
    const jobsByCompany = R.applyTo(jobs, R.pipe(
      R.groupBy(R.prop('company')),
      R.toPairs,
      R.map(R.over(R.lensIndex(1), R.sortBy(R.identity))),
    ));
    
    
    return jobsByCompany.map(([companyId, jobs], i) => {
      const company = companies.find(({ slug }) => slug === companyId);
      const hasOlder = (jobs.length > 1);
      const className = classnames(styles.job, { [styles.hasOlder]: hasOlder });

      return (
        <Jobs
          className={ className }
          key={ companyId }
          jobs={ jobs }
          company={ company } />
      );
    });
  }
  
  render() {
    const { className } = this.props;
    
    const classes = classnames(className, styles.jobList);
    return (
      <div className={ classes }>
        { this.jobs }
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/JobList/index.jsx